import { render, staticRenderFns } from "./Approve.vue?vue&type=template&id=c28f8862&scoped=true"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"
import style0 from "./Approve.vue?vue&type=style&index=0&id=c28f8862&prod&scoped=true&lang=css"
import style1 from "./Approve.vue?vue&type=style&index=1&id=c28f8862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28f8862",
  null
  
)

export default component.exports